import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Diagnosis } from "@project/diagnosis/diagnosis";
import { IEpisode } from "@project/models/episodes/episode";

@Component({
    selector: "episode-header-title-v3",
    template: `
    <div class="all-list-details"  [ngClass]="{'border-red': !episode && isBorderHighlightEnabled }" >
        <div style="color:rgb(101, 136, 148);" *ngIf="!episode; else showDianoses" >Please Select Episode  </div>
      
        <ng-template #showDianoses>
            <div *ngIf="episode && episode.diagnoses.length > 0">
                <div class="diagnoses-lists" >
                    <div>
                        <span *ngFor="let diagnose of episode.diagnoses"  >
                            <div>
                                {{ diagnose.diagnosisName }}
                                <ng-container *ngIf="diagnose.diagnosisBodyPartName !== 'N/A'">
                                    <i class="pi pi-minus ml-1 mr-1"></i> {{ diagnose.diagnosisBodyPartName }}
                                </ng-container>
                                <ng-container *ngIf="diagnose.bodySide !== 'N/A' && diagnose.bodySide !=='' " >
                                    <span class="mip-divider">|</span> {{ diagnose.bodySide }}
                                </ng-container>
                                <ng-container *ngIf="diagnose.diagnosisMedicalSystemName">
                                    <span class="mip-divider">|</span> {{ diagnose.diagnosisMedicalSystemName }}
                                </ng-container>
                            </div>
                        </span>
                    </div>
                    <div *ngIf="showActionButton">
                        <button *ngIf="showEditButton" doNotPropagateClick pButton allowOffline type="button" icon="mi mi-button-edit" class="p-button-secondary p-button-text" (click)="onEdit()">
                        </button>
                        <button *ngIf="showDeleteButton" doNotPropagateClick pButton allowOffline type="button" icon="mi mi-button-remove text-danger" class="p-button-secondary p-button-text" (click)="onDelete()">
                        </button>
                    </div>
                </div> 
            </div>
        </ng-template>
    </div>`,
    styleUrls: ["./episode-header-title.component.scss"]
})
export class EpisodeHeaderTitleV3Component {
    
    
    @Output() readonly delete = new EventEmitter<string>();
    @Output() readonly edit =  new EventEmitter<string>();

    @Input() episode: IEpisode = null;
    @Input() showActionButton  = true;
    @Input() showEditButton  = true;
    @Input() showDeleteButton  = true;
    @Input() isBorderHighlightEnabled  = false;


    onDelete() {
        this.delete.emit()
    }
    onEdit() {
        this.edit.emit()
    }

}
